import { render, staticRenderFns } from "./AllArchives.vue?vue&type=template&id=03df39a9&"
import script from "./AllArchives.vue?vue&type=script&lang=js&"
export * from "./AllArchives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports